import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NgrxStoreKeys } from '@warema/warema-plus/models';
import { productCategoriesAdapter, ProductCategoryState } from './product-category.reducers';

const { selectAll } = productCategoriesAdapter.getSelectors();
const selectFeatureProjectCategoryState = createFeatureSelector<ProductCategoryState>(
    NgrxStoreKeys.PRODUCT_CATEGORY_FEATURE_KEY,
);
const windowSubCategoryIdPrefix = '1';
const patioSubCategoryIdPrefix = '3';
const controlSystemsCategoryIdPrefix = '4';

export const selectAllProductCategories = createSelector(
    selectFeatureProjectCategoryState,
    (state: ProductCategoryState) => selectAll(state),
);

export const selectAllSelectedProductCategoriesIds = createSelector(
    selectFeatureProjectCategoryState,
    (state: ProductCategoryState) =>
        selectAll(state)
            .flatMap(p => p.productCategories)
            .filter(p => p.selected)
            .map(p => p.id),
);

export const selectSelectedProductCategoriesNames = createSelector(
    selectFeatureProjectCategoryState,
    (state: ProductCategoryState) =>
        selectAll(state)
            .flatMap(p => p.productCategories)
            .filter(p => p.selected)
            .map(p => p.name),
);

export const selectIsPatioSelected = createSelector(selectFeatureProjectCategoryState, (state: ProductCategoryState) =>
    selectAll(state)
        .flatMap(p => p.productCategories)
        .filter(p => p.selected)
        .map(p => p.id.toString())
        .some(p => p.startsWith(patioSubCategoryIdPrefix)),
);

export const selectIsWindowSelected = createSelector(selectFeatureProjectCategoryState, (state: ProductCategoryState) =>
    selectAll(state)
        .flatMap(p => p.productCategories)
        .filter(p => p.selected)
        .map(p => p.id.toString())
        .some(p => p.startsWith(windowSubCategoryIdPrefix)),
);

export const selectOnlyControlSystemsSelected = createSelector(
    selectFeatureProjectCategoryState,
    (state: ProductCategoryState) => {
        const selectedCategories = selectAll(state)
            .flatMap(p => p.productCategories)
            .filter(p => p.selected)
            .map(p => p.id.toString());

        return (
            selectedCategories.length > 0 && selectedCategories.every(p => p.startsWith(controlSystemsCategoryIdPrefix))
        );
    },
);

export const selectAllSelectedProductCategoriesTranslationKeys = createSelector(
    selectFeatureProjectCategoryState,
    (state: ProductCategoryState) =>
        selectAll(state)
            .flatMap(p => p.productCategories)
            .filter(p => p.selected)
            .map(p => `PRODUCT_CATEGORY.${p.name}`),
);
